import getLogRocket from '@ui/analytics/logRocket'
import { FillLoginForm } from '@ui/components/contact/FillLoginForm'
import { EnterCodeForm } from '@ui/components/contact/EnterCodeForm'
import { OrderNumberForm } from '@ui/components/contact/OrderNumberForm'
import { LoginStep } from '@ui/components/contact/enum'
import Footer from '@ui/components/shared/Footer'
import Header from '@ui/components/shared/Header'
import { getLocalObject, sleep } from '@ui/helpers'
import { useServerMounted, useRedirect } from '@ui/hooks'
import { LocalContact } from '@ui/modules'
import { useRouter } from 'next/router'
import { useContext, useEffect, useState, useRef } from 'react'
import Loading from '../../components/shared/Loading'
import css from 'styled-jsx/css'
import ServeByShopHelp from '../../components/shared/ContactForm/ServeByShopHelpCF'
import { SupportInfo } from '@ui/components/shared/ContactForm/SupportInfo'
import getConfig from 'next/config'
import { ShopHelpLocalKey, useOrderService } from '@ui/services'
import { useAuthService } from '@ui/services/auth/auth.service'
import { OrderContext } from '@ui/contexts'
import { useGlobalState } from '@libs/client'

const ContactPage = () => {
  const redirect = useRedirect()
  const router = useRouter()
  // const [storeSetting] = useSetting('store')
  const isServerMounted = useServerMounted()
  const [currentStep, setCurrentStep] = useState<string>(LoginStep.SKIP)
  const [loading, setLoading] = useState<boolean>(false)
  const { dispatchOrder } = useContext(OrderContext)
  const [, setOrderDetail] = useGlobalState<Types.OrderShopHelp>(ShopHelpLocalKey.ORDER_DETAIL)
  const [supportDisplayStatus, setSupportDisplayStatus] = useState<boolean>(false)
  const IS_AUTHEN_TWO_STEP = 'IS_AUTHEN_TWO_STEP'
  const AUTH_LOGIN = 'AUTH_LOGIN'
  const LOCAL_LIST_ORDER = 'LOCAL_LIST_ORDER'

  const [, setLoginData] = useState<{ email: string; order: string }>({
    email: '',
    order: ''
  })
  const [searchForm, setSearchForm] = useState<{ email: string; phone: string }>({
    email: '',
    phone: ''
  })
  const { detailByInfoAuth } = useOrderService(getConfig().publicRuntimeConfig.shophelpBasePathApi)
  const { login } = useAuthService(getConfig().publicRuntimeConfig.shophelpBasePathApi)
  const prevStepRef = useRef<any>()

  async function onNextStep(nextStep?: string) {
    prevStepRef.current = currentStep
    setLoading(true)
    await sleep(500)
    if (nextStep && typeof nextStep === 'string') {
      setCurrentStep(nextStep)
      setLoading(false)
      return
    }
    setLoading(false)
  }

  async function setLocalOrder(body: Types.LoginModel) {
    try {
      const localAuth = getLocalObject(AUTH_LOGIN)
      let result = true
      if (!localAuth || !localAuth.access_token) {
        result = await login(body).then((data) => {
          if (data === undefined) {
            return false
          }
          return true
        })
      }

      if (result) {
        await detailByInfoAuth(body).then((res) => {
          dispatchOrder({ type: 'REPLACE', payload: res })
          setOrderDetail(res)
        })
        redirect('/order', { routerOptions: { scroll: false } })
      } else {
        setCurrentStep(LoginStep.EMAIL)
        setLoading(false)
      }
    } catch (err: any) {
      console.log('Error at setLocalOrder() function')
      checkDataLocalExisted()
      setLoading(false)
    }
  }

  function checkDataLocalExisted() {
    const localListOrder = getLocalObject(LOCAL_LIST_ORDER)
    const localAuth = getLocalObject(AUTH_LOGIN)
    if (
      localAuth &&
      localAuth.access_token &&
      (localAuth.email || localAuth.phone) &&
      localListOrder &&
      localListOrder.length > 0
    ) {
      redirect('/order', { routerOptions: { scroll: false } })
    } else {
      setCurrentStep(LoginStep.EMAIL)
    }
  }

  async function loginToSendCode(localAuth: any) {
    let body: Types.LoginModel
    {
      localAuth.phone
        ? (body = {
            phone: localAuth.phone,
            send_sms: true
          })
        : (body = {
            email: localAuth.email,
            send_sms: false
          })
    }
    //console.log(body);
    await login(body).then((data) => {
      //console.log(data);
      if (data) {
        setCurrentStep(LoginStep.CODE)
        setLoading(false)
      } else {
        setCurrentStep(LoginStep.EMAIL)
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    // if (process.env.env == 'prd')
    //   isAlphaTestDomain(storeSetting?.general.domain ?? '') && getLogRocket().logRocket?.init()
    // else getLogRocket().logRocket?.init()
    getLogRocket().logRocket?.init()
  }, [])

  useEffect(() => {
    if (process.browser) {
      const localContact = getLocalObject(LocalContact.contactKey)
      const query = router.query

      setLoginData((body) => {
        if (query && (query.email || query.order)) {
          return { email: query.email || '', order: query.order || '' }
        }
        if (localContact && (localContact.email || localContact.order)) {
          return {
            email: localContact.email || '',
            order: localContact.order_name || localContact.order || ''
          }
        }
        return { ...body }
      })
    }
  }, [])

  //check_auth
  useEffect(() => {
    ;(async () => {
      if (process.browser) {
        setLoading(true)
        const localAuthTwoStep = getLocalObject(IS_AUTHEN_TWO_STEP)
        const localContactForm = getLocalObject(LocalContact.contactKey)
        const localListOrder = getLocalObject(LOCAL_LIST_ORDER)
        const localAuth = getLocalObject(AUTH_LOGIN)
        const query = router.query
        if (query && (query.email || query.order)) {
          //via mail
          const body: Types.LoginModel = {
            email: query.email as string,
            order: query.order as string
          }
          await setLocalOrder(body).then()
        } else if (
          localContactForm?.email &&
          (localContactForm?.order_name || localContactForm?.order)
        ) {
          //via cache
          const body: Types.LoginModel = {
            email: localContactForm.email,
            order: localContactForm.order_name || localContactForm.order
          }
          await setLocalOrder(body).then()
        } else if (localAuthTwoStep) {
          //when users logined via 2 steps successfully in the past.
          if (!localAuth || (!localAuth.email && !localAuth.phone)) {
            setCurrentStep(LoginStep.EMAIL)
            setLoading(false)
          } else if (!localListOrder || localListOrder.length == 0) {
            loginToSendCode(localAuth)
          } else {
            redirect('/order', { routerOptions: { scroll: false } })
          }
        } else {
          //when users logined via enter code or phone but dropped in the past.
          if (localAuth && (localAuth.email || localAuth.phone)) {
            loginToSendCode(localAuth)
          } else {
            setCurrentStep(LoginStep.EMAIL)
            setLoading(false)
          }
        }
      }
    })()
  }, [router])

  return !isServerMounted ? (
    <>
      <style jsx>{compStyle}</style>
      {loading && <Loading isFullWidth />}
      <Header />

      <div className="tracking-form-page">
        <div className="wrapper">
          <section className="container section section--medium">
            {currentStep == LoginStep.EMAIL && (
              <FillLoginForm
                currentStep={currentStep}
                nextStep={(nextStep?: any) => onNextStep(nextStep)}
                setDisplayStatus={setSupportDisplayStatus}
                setSearchForm={setSearchForm}
                setCurrentStep={setCurrentStep}
              />
            )}
            {currentStep == LoginStep.CODE && (
              <EnterCodeForm
                nextStep={(nextStep?: any) => onNextStep(nextStep)}
                prevStep={prevStepRef.current}
                setDisplayStatus={setSupportDisplayStatus}
                searchForm={searchForm}
              />
            )}
            {currentStep == LoginStep.ORDER && (
              <OrderNumberForm
                nextStep={(nextStep?: any) => onNextStep(nextStep)}
                prevStep={prevStepRef.current}
                setDisplayStatus={setSupportDisplayStatus}
                searchForm={searchForm}
              />
            )}
          </section>
        </div>
      </div>
      {supportDisplayStatus && <SupportInfo className="ml-0" />}
      <ServeByShopHelp className="ml-4" />
      <Footer />
    </>
  ) : null
}

const compStyle = css`
  .section--medium {
    padding-bottom: 90px;
  }

  @media screen and (max-width: 768px) {
    .section {
      padding-top: 10px !important;
    }
  }
`

export default ContactPage
